import React, { useState, useEffect } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
//Component
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import FormInput from "../../stories/hook-controls/input";
import FormCheckBox from "../../stories/hook-controls/checkbox";
import ComboEncrypType from "../../stories/selection-control/combo/encryp-type";
import { Modal } from "../../stories/modal";
import { ReactTable } from "../../stories/react-table";
//Function
import { setDataToFormHookV2, isEmptyStr } from "../../utils/common-function";
import { getMasterColumns } from "./columns/encrypt-map-master";
import { buildParameter } from "./parameter";
import * as alertDialog from "../../utils/alert";
import * as api from "./api";

function EncryptMapMaster() {
  //Context

  //State
  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [DataList, setDataList] = useState([]);
  const [DataDetail, setDataDetail] = useState({});

  //Event
  const onOpenAddModal = () => {
    setOpenModal(true);
    setEditMode(false);
    setDataDetail(null);
  };
  const onOpenEditModal = () => {
    setOpenModal(true);
    setEditMode(true);
  };
  const onCloseModal = () => {
    setOpenModal(false);
  };

  //Function
  const Edit = (Detail) => {
    onOpenEditModal();
    setDataDetail(Detail);
  };

  const Delete = async (id) => {
    let res = await alertDialog.ConfirmDelete();
    if (!res) return;

    let param = {
      ENCRYPT_ID: id,
    };

    let api_res = await api.DeleteEncryptMap(param);
    if (!api_res) return;
    fetch();
    alertDialog.del_success();
  };

  //--------
  const fetch = async () => {
    let res = await api.GetListEncryptMapMaster();
    setDataList(res);
  };
  useEffect(() => {
    fetch();
  }, []);

  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1
          height="80vh"
          title="Encrypt Map Master"
          // add
          // onClickAdd={onOpenAddModal}
        >
          <ReactTable
            keyField="ENCRYPT_ID"
            data={DataList}
            columns={getMasterColumns(Edit, Delete)}
            addButton={true}
            handleOnAdd={(e) => onOpenAddModal()}
          />
        </BoxTemplate1>
        <DataModal
          open={openModal}
          editmode={editMode ? 1 : 0}
          onClose={onCloseModal}
          search={fetch}
          datadetail={DataDetail}
        />
      </BaseContainer>
    </div>
  );
}

function DataModal(props) {
  const { onClose } = props;
  const { open, editmode } = props;
  const { datadetail, search = () => {}, ...otherprops } = props;
  const method = useForm();
  const { setValue, getValues, setError, clearErrors, errors } = method;

  //Event

  //Effect
  useEffect(() => {
    if (!open) return;

    if (editmode) {
      let data = setDataToFormHookV2(datadetail);
      setTimeout(() =>
        data?.forEach(({ name, value }) => setValue(name, value))
      );
    } else {
      setTimeout(() => setValue("ACTIVE", true));
    }
  }, [datadetail, setValue, open, editmode]);

  const SaveDetail = async () => {
    clearErrors("ENCRYPT_NAME");
    clearErrors("ENCRYPT_TYPE_ID");

    const ENCRYPT_NAME = getValues().ENCRYPT_NAME;
    const ENCRYPT_TYPE_ID = getValues().ENCRYPT_TYPE_ID.toString();

    if (isEmptyStr(ENCRYPT_NAME)) {
      setError("ENCRYPT_NAME", {
        type: "manual",
        message: "The Encrypt Name field is required",
      });
      return;
    }

    if (isEmptyStr(ENCRYPT_TYPE_ID)) {
      setError("ENCRYPT_TYPE_ID", {
        type: "manual",
        message: "The Encrypt Type field is required",
      });
      return;
    }

    const ID = editmode ? datadetail.ENCRYPT_ID : null;
    let param = buildParameter.SaveDetail(ID, getValues());

    let res = await api.SaveEncryptMap(param);
    if (res) {
      search();
      onClose();
      alertDialog.inform_success();
    }
  };

  return (
    <div>
      <Modal
        {...otherprops}
        onSave={SaveDetail}
        title={editmode ? "Edit Encrypt Map" : "Add Encrypt Map"}
      >
        <FormProvider {...method}>
          <Box m={3} maxWidth="500px" flexGrow={1} className="box-input">
            {editmode === 1 && (
              <Typography variant="subtitle2" display="block" gutterBottom>
                Encrypt Map ID : {datadetail.ENCRYPT_ID}
              </Typography>
            )}
          </Box>
          <Box m={3} maxWidth="500px" flexGrow={1} className="box-input">
            <FormInput
              required
              name="ENCRYPT_NAME"
              label="Encrypt Map Name"
              errorobj={errors}
            />
          </Box>
          <Box m={3} maxWidth="500px" flexGrow={1} className="box-input">
            <ComboEncrypType
              name="ENCRYPT_TYPE_ID"
              label="Encrypt Type"
              errorobj={errors}
              required
            />
          </Box>
          <Box
            mt={3}
            ml={4.5}
            maxWidth="500px"
            flexGrow={1}
            style={{ marginTop: "0" }}
          >
            <FormCheckBox
              key="ACTIVE"
              name="ACTIVE"
              label="Active"
              errorobj={errors}
            />
          </Box>
        </FormProvider>
      </Modal>
    </div>
  );
}
export default EncryptMapMaster;
